﻿export enum PlanTypes {
    None,
    HMO,
    PPO,
}